import React from "react";
import CarouselSection from "../CarouselSection";

const Robots = (props) => {
  return <CarouselSection />;
};

export default Robots;
